import { Button, Heading, LuIcon, Text } from "@overmap-ai/blocks"
import { Link } from "@tanstack/react-router"
import { memo } from "react"

import { ViewContainer } from "../../components/Containers/ViewContainer"
import { modelIconMapping } from "../../mappings/icons"

export const NotFound = memo(() => {
	return (
		<ViewContainer maxWidth="4xl">
			<div className="flex size-full items-center justify-center">
				<div className="flex flex-col items-center gap-2">
					<Heading size="xl">Asset type not found</Heading>
					<Text accentColor="base">The requested asset type does not exist in this project</Text>
					<Link
						from="/$organizationId/$projectId/asset-types/$assetTypeId/"
						to="/$organizationId/$projectId/asset-types"
					>
						<Button variant="ghost">
							<LuIcon icon={modelIconMapping.arrowLeft} />
							Back to asset types
						</Button>
					</Link>
				</div>
			</div>
		</ViewContainer>
	)
})
NotFound.displayName = "NotFound"
